// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2BlW0","title":"FrontImage_title__3MCZc"};